import React from 'react';
import IconPackage from 'xiv-fanfes-2021';
import styled from '@emotion/styled';
import * as breakpoint from '../../styles/breakpoints.module.scss';

const SectionHeadline = (props) => {
  let { icon, title, subtitle,color,category } = props;

  return(
    <HeadlineWrapper iconColor={color} className="sectionHeadline" {...props}>
      {icon && 
        <IconPackage.Icon type={icon} />
      }
      {category &&
        <Category className="category">{category}</Category>
      }
      <Title className="title">{title}</Title>
      {subtitle && 
        <Subtitle className="subtitle">{subtitle}</Subtitle>
      }
    </HeadlineWrapper>
  );
}

export default SectionHeadline;


const HeadlineWrapper = styled.h2`
  position:relative;
  z-index:2;
  text-align:center;
  font-size:0;
  svg{
    color:${props => props.iconColor};
    width: 64px;
    height: 64px;
    margin-bottom:16px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    svg{
      width:56px;height:56px;margin-bottom:12px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:0 0px;
    svg{
      width:48px;height:48px;margin-bottom:8px;
    }
  }
  


`

const Category = styled.span`
  display:block;
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: #D00F31;
  margin-bottom:12px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    
    font-size: 12px;
    line-height: 16px;
    margin-bottom:4px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:0px;
    font-size: 10px;
    line-height: 14px;
  }
`


const Title = styled.span`
  display:block;
  font-weight: 900;
  font-size: 48px;
  line-height: 56px;
  letter-spacing: 0.05em;
  color: #2C2C2E;
  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 36px;
    line-height: 48px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 24px;
    line-height: 32px;
  }
`

const Subtitle = styled.span`
  display:block;
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: #787880;
  margin-top:16px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:12px;
    font-size: 14px;
    line-height: 20px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:8px;
    font-size: 12px;
    line-height: 16px;
  }
`
